// Device ID utility for guest session tracking

/**
 * Get or create a persistent device ID stored in localStorage
 * This ID is used to track guest sessions across browser restarts
 * @returns {string} Device ID
 */
export function getOrCreateDeviceId() {
  const key = 'deviceId';
  let id = localStorage.getItem(key);

  if (!id) {
    // Use crypto.randomUUID if available (modern browsers)
    if (crypto.randomUUID) {
      id = crypto.randomUUID();
    } else {
      // Fallback for older browsers
      id = `${Date.now()}-${Math.random().toString(36).substring(2, 15)}`;
    }

    localStorage.setItem(key, id);
    console.log('📱 [DEVICE] Created new device ID:', id.substring(0, 8) + '...');
  }

  return id;
}

/**
 * Clear the device ID (for testing or logout)
 */
export function clearDeviceId() {
  localStorage.removeItem('deviceId');
  console.log('📱 [DEVICE] Cleared device ID');
}
